import React, { useMemo } from 'react';
import Select from 'react-select';
import Datepicker from 'react-tailwindcss-datepicker';

const FilterBar = ({
  dateRange,
  onDateChange,
  designer,
  onDesignerChange,
  designerOptions,
  showDesigner = true,
  status,
  onStatusChange,
  statusOptions,
  showStatus = true,
  adType,
  onAdTypeChange,
  adTypeOptions = [],
  showAdType = true,
  search = '',
  onSearchChange,
  showSearch = true,
}) => {
  return (
    <div className="flex flex-wrap gap-4 mb-4 items-end">
      <div className="w-64">
        <label className="block text-xs font-semibold mb-1">Start Date Range</label>
        <div className='border rounded-lg border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 w-66'>
          <Datepicker
            value={dateRange}
            onChange={onDateChange}
            primaryColor="cyan"
            showShortcuts={true}
            classNames="form-input"
            asSingle={false}
          />
        </div>
      </div>
      {showSearch && (
        <div className="w-64">
          <label className="block text-xs font-semibold mb-1">Search</label>
          <input
            type="text"
            className="w-full border rounded px-2 py-1"
            placeholder="Search by campaign/brand/client"
            value={search}
            onChange={(e) => onSearchChange && onSearchChange(e.target.value)}
          />
        </div>
      )}
      {showAdType && (
        <div className="w-64">
          <label className="block text-xs font-semibold mb-1">Ad Type</label>
          <Select
            options={adTypeOptions}
            value={adType}
            onChange={onAdTypeChange}
            isClearable
            placeholder="Select Ad Type"
            classNamePrefix="react-select"
          />
        </div>
      )}
      {showDesigner && (
        <div className="w-64">
          <label className="block text-xs font-semibold mb-1">Designer</label>
          <Select
            options={designerOptions}
            value={designer}
            onChange={onDesignerChange}
            isClearable
            placeholder="Select Designer"
            classNamePrefix="react-select"
          />
        </div>
      )}
      {showStatus && (
        <div className="w-64">
          <label className="block text-xs font-semibold mb-1">Design Status</label>
          <Select
            options={statusOptions}
            value={status}
            onChange={onStatusChange}
            isClearable
            placeholder="Select Status"
            classNamePrefix="react-select"
          />
        </div>
      )}
    </div>
  );
};

export default FilterBar; 